
import { Component, Prop, Vue } from 'vue-property-decorator';
import PriceSummary from '@/pages/shared/CampaignWizard/components/PriceSummary.vue';
import PromoCodeInput from '@/shared-components/PromoCodeInput.vue';
import { Action, Getter } from 'vuex-class';
import namespaces from '@/store/namespaces';
import { Discount } from '@/types/promotions';
import { LocationData, LocationPrice } from '@/types/locations';
import { TimeSlotSelection } from '@/types/time-slots';
import { CheckoutCampaign } from '@/store/modules/campaign-wizard/types';
import { getLocationPriceByFrequency } from '@/utils/locations';
import IButton from '@/ui-components/IButton/IButton.vue';

@Component({
  components: {
    IButton,
    PriceSummary,
    PromoCodeInput,
  }
})
export default class RightPaymentSection extends Vue {
  @Prop({}) closeSheet!: Function;
  @Prop({}) isLoading!: boolean;

  @Getter('discounts', { namespace: namespaces.CampaignWizardModule })
  public discounts!: Discount[];
  @Getter('selectedLocations', { namespace: namespaces.CampaignWizardModule })
  public selectedLocations!: LocationData[];
  @Getter('time', { namespace: namespaces.CampaignWizardModule })
  public timeSlotSelection!: TimeSlotSelection;


  @Action('checkoutCampaign', { namespace: namespaces.CampaignWizardModule })
  public checkoutCampaign!: CheckoutCampaign;


  public promoCodeLoading = false;
  locationPrices = {} as Record<LocationData['ID'], LocationPrice>;

  public async loadCheckoutData() {
    try {
      this.promoCodeLoading = true;
      await this.checkoutCampaign();
    } catch (error) {
      console.log('Failed to load checkout data:', error);
    } finally {
      this.promoCodeLoading = false;
    }
  }

  updatePrice() {
    const {
      frequency
    } = this.timeSlotSelection;
    this.locationPrices = this.selectedLocations.reduce((selectedLocations, selectedLocation: LocationData) => {
      return {
        ...selectedLocations,
        [selectedLocation.clusterId]: {
          BASE_PRICE: getLocationPriceByFrequency(selectedLocation, frequency)
        }
      }
    }, {})
  }

  created() {
    this.updatePrice()
  }
}
